export default {
  titleCase (str) {
    return str && str.toLowerCase().split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
  },
  seoMerchantName (str) {
    const type = {
      cv: 'CV',
      pt: 'PT'
    }
    let result = this.titleCase(str.replace(/toko/i, ''))
        result = result.replace(/^\s+/g, '') // remove space in start string
        result = result.replace(/\s+$/g, '') // remove space in end string
        result = result.replace(/cv|pt/gi, (matched) => type[matched.toLowerCase()])
    return result
  }
}
